import React from 'react';
import ResponsiveImage from 'components/ResponsiveImage';
import PoorText from 'components/PoorText';
import Icon from 'components/Icon';
import PropTypes from 'prop-types';
import { breakpoints } from 'js/breakpoints';
import fallbackImageSrc from '../../assets/image-placeholder-light.svg';
const fallbackImage = {
  src: fallbackImageSrc,
};

const SectionListItem = ({
  heading,
  url,
  image,
  introHtml,
  isRestricted,
  restrictedLabel,
  headingTagLevel = 3,
}) => {
  const HeadingTag = `h${headingTagLevel}`;
  const ItemWrapper = url ? 'a' : 'div';

  return (
    <ItemWrapper href={url} className="section-list-item">
      <div className="section-list-item__content">
        <HeadingTag className="section-list-item__heading">
          {heading}
        </HeadingTag>
        {introHtml && (
          <PoorText
            text={introHtml}
            className="section-list-item__intro poor-text_in-section-list-item"
          />
        )}
      </div>
      <div className="section-list-item__image">
        <ResponsiveImage
          {...(image ?? fallbackImage)}
          loading="lazy"
          className="responsive-image_size_section-list-item"
          sources={[
            {
              width: 100,
              height: 100,
              media: breakpoints.m,
            },
            {
              width: 206,
              height: 190,
              media: breakpoints.l,
            },
          ]}
        />
        {isRestricted && (
          <div className="section-list-item__restricted">
            <Icon use="key" className="section-list-item__restricted-icon" />
            <span
              dangerouslySetInnerHTML={{
                __html: restrictedLabel,
              }}
              className="section-list-item__restricted-text"
            />
          </div>
        )}
      </div>
    </ItemWrapper>
  );
};

SectionListItem.propTypes = {
  heading: PropTypes.string,
  url: PropTypes.string,
  introHtml: PropTypes.string,
  image: PropTypes.exact(ResponsiveImage.propTypes),
  isRestricted: PropTypes.bool.isRequired,
  restrictedLabel: PropTypes.string.isRequired,
  headingTagLevel: PropTypes.oneOf([2, 3]),
};

export default SectionListItem;
